(function () {
    // console.log('[CUSTOM] Final Variant Carousel Loaded');

    /* ================================
       1. IMAGE MAP
       ================================ */

    const VARIANT_MEDIA_ORDER = {
        OG: [
            '39461319508210', // OG-1
            '39461319704818', // OG-2
            '39461319147762', // OG-3
            '39461319409906', // OG-4
            '39558679789810', // Both-5
            '39461319377138', // Both-6
            '39461319475442', // Both-7
            '39471027749106' // Both-8-Updated
        ],
        Sours: [
            '39461319606514', // Sour-1
            '39461319672050', // Sour-2
            '39461319540978', // Sour-3
            '39461319639282', // Sour-4
            '39558679789810', // Both-5
            '39461319377138', // Both-6
            '39461319475442', // Both-7
            '39471027749106'// Both-8-Updated
        ]
    };

    /* ================================
       2. STATE
       ================================ */

    let currentIndex = 0;
    let activeImages = [];
    let activeThumbs = [];

    const gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    const mainImages = Array.from(gallery.querySelectorAll('.shop-main-image'));
    const thumbnails = Array.from(gallery.querySelectorAll('.shop-thumbnail'));

    const prevBtns = gallery.querySelectorAll('.shop-mobile-prev-arrow, .shop-desktop-prev-arrow');
    const nextBtns = gallery.querySelectorAll('.shop-mobile-next-arrow, .shop-desktop-next-arrow');

    /* ================================
       3. RESET
       ================================ */

    function resetAll() {
        mainImages.forEach(img => {
            img.removeAttribute('data-allowed');
            img.classList.remove('active');
            img.style.display = 'none';
        });

        thumbnails.forEach(thumb => {
            thumb.removeAttribute('data-allowed');
            thumb.classList.remove('active');
        });

        activeImages = [];
        activeThumbs = [];
        currentIndex = 0;
    }

    /* ================================
       4. SHOW IMAGE
       ================================ */

    function showImage(index) {
        if (!activeImages.length) return;

        activeImages.forEach((img, i) => {
            const active = i === index;
            img.classList.toggle('active', active);
            img.style.display = active ? 'block' : 'none';
        });

        activeThumbs.forEach((thumb, i) => {
            thumb.classList.toggle('active', i === index);
        });

        currentIndex = index;
    }

    /* ================================
       5. APPLY VARIANT
       ================================ */

    function applyVariant(variant) {
        const order = VARIANT_MEDIA_ORDER[variant];
        if (!order) return;

        console.log('[CUSTOM] Applying variant:', variant);
        resetAll();

        order.forEach((id, index) => {
            const img = mainImages.find(i => i.dataset.mediaId === id);
            const thumb = thumbnails.find(
                t =>
                    t.dataset.mediaId === id ||
                    t.querySelector('img')?.dataset.mediaId === id
            );

            if (!img || !thumb) return;

            img.setAttribute('data-allowed', 'true');
            thumb.setAttribute('data-allowed', 'true');

            thumb.onclick = () => showImage(index);

            activeImages.push(img);
            activeThumbs.push(thumb);
        });

        if (activeImages.length) {
            requestAnimationFrame(() => showImage(0));
        }

        updateQuantity4Flavor(variant);
    }

// to update the "One Time Purchase" Variant Seletor
function updateQuantity4Flavor(variant) {
    const select = document.querySelector(
        '.quantity-break-variant-select[data-quantity-option="4"]'
    );

    if (!select) return;

    const targetValue = `${variant} - One Time`;
    const option = Array.from(select.options)
        .find(opt => opt.value === targetValue);

    if (!option) return;

    // ⏱ Defer to beat app re-render
    requestAnimationFrame(() => {
        option.selected = true;
        select.value = targetValue;

        // Force native events (important)
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));

        // Force repaint for some themes
        select.blur();
        select.focus();

        // console.log('[CUSTOM] UI forced to:', targetValue);
    });
}

    /* ================================
       6. ARROWS
       ================================ */

    function next() {
        if (!activeImages.length) return;
        showImage((currentIndex + 1) % activeImages.length);
    }

    function prev() {
        if (!activeImages.length) return;
        showImage((currentIndex - 1 + activeImages.length) % activeImages.length);
    }

    prevBtns.forEach(btn => (btn.onclick = prev));
    nextBtns.forEach(btn => (btn.onclick = next));

    /* ================================
       7. SWIPE (SAFE)
       ================================ */

    let startX = 0;
    let startY = 0;

    gallery.addEventListener('touchstart', e => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
    }, { passive: true });

    gallery.addEventListener('touchend', e => {
        const diffX = e.changedTouches[0].clientX - startX;
        const diffY = e.changedTouches[0].clientY - startY;

        if (Math.abs(diffY) > Math.abs(diffX)) return;
        if (Math.abs(diffX) < 40) return;

        diffX < 0 ? next() : prev();
    }, { passive: true });

    /* ================================
       8. VARIANT PICKER
       ================================ */

    document.addEventListener('click', e => {
        const label = e.target.closest('.simple-variant-picker__image-variant');
        if (!label) return;

        const input = document.getElementById(label.getAttribute('for'));
        if (!input) return;

        applyVariant(input.value);
    }, true);

    /* ================================
       9. INITIAL LOAD
       ================================ */

    document.addEventListener('DOMContentLoaded', () => {
        const checked = document.querySelector(
            '.simple-variant-picker__radio[name="options[Flavor]"]:checked'
        );
        if (checked) applyVariant(checked.value);
    });
})();
